import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { VisaApplicationService } from '@univacity/angular/datas';
import { VisaApplication } from '@univacity/shared/types';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VisaApplicationResolver
  implements Resolve<Observable<VisaApplication>>
{
  constructor(private svc: VisaApplicationService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<VisaApplication> {
    return this.svc.findOne(route.params['id'], {
      populate: ['invoice'],
    });
  }
}
